// extracted by mini-css-extract-plugin
export default {"body":"Trade_body__BQ2NN","left-column":"Trade_left-column__2Vcaw","right-column":"Trade_right-column__atcnt","button":"Trade_button__-qwUU"};